module.exports = __webpack_public_path__ + "static/media/Glazbeno-scenki prikaz-foto 6.a6f7a344.jpg";